import events from 'lib/events';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SearchField from 'components/searchField';
import session from 'services/sessionService';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';
import Header from 'components/layout/header';
import ArticleContents from 'components/articles/articleContents';
import encyclopediaApi from 'api/encyclopedia';
import EncyclopediaResults  from './encyclopediaResults.jsx';
import Loader from 'components/loader';
import EncyclopediaArticle from './encyclopediaArticle';
import FileBrowser from 'components/file-browser/file-browser';

let render = (container, params) => {
  console.info('[UI.page.encyclopedia] rendering page');
  let {query, topic} = session.popSearch();

  ReactDOM.render(<IntlWrapper><WrappedEncyclopediaPage query={query} topic={topic} articleSlug={params.articleSlug} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'encyclopedia'});
};

console.info('[UI.page.encyclopedia] register route');
router.rr.add([{path: 'encyclopedia', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'encyclopedia/:articleSlug', handler: routeUtils.requireAuth(render)}]);

// Page object
class EncyclopediaPage extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      topic: props.topic || '',
      query: '',
      page: 1,
      results: {},
      videosOnly: false,
      article: null,
      topics: [],
      defaultToPreviousEncyclopediaOverview: false,
    };
  }

  componentWillMount() {
    this._supportClearListener = events.subscribe('supportclear', () => {
      this.revertSearch();
      this.setWelcomeEncyclopediaMessage();
    });

    if (this.props.query) {
      this.filterChange(this.props.query);
    }
  }

  componentDidMount() {
    this.setWelcomeEncyclopediaMessage();
  }

  componentWillUnmount() {
    this._supportClearListener.remove();
  }

  componentDidUpdate(prevProps) {
    if (this.props.intl.locale !== prevProps.intl.locale) {
      this.setWelcomeEncyclopediaMessage();
    }
  }

  onPageChange = page => this.setState({page: page}, this.performSearch);

  changeHandler = (property, after = null, valueProperty = 'value') =>
    event =>
      this.setState({
        [property]: event.target[valueProperty],
      }, after || (() => {
      }));

  filterChange = term => {
    this.setState({query: term, page: 1}, this.performSearch);
  };

  navigateToArticle = slug => {
    window.location.hash = `encyclopedia/${slug}`;
  };

  setWelcomeEncyclopediaMessage = () => {
    this.setState({article: null});
    encyclopediaApi.encyclopediaWelcomePage(this.props.intl.locale).then(article => {
      this.setState({article: {title: article.title, body: article.detailedSection, id: article.id, fav: article.fav}, defaultToPreviousEncyclopediaOverview: false});
    }).catch(error => {
      console.error(error);
      this.setState({defaultToPreviousEncyclopediaOverview: true});
    });
  }

  performSearch = () => {
    this.setState({results: null, article: null, hasBeenSearched: true});
    window.location.hash = 'encyclopedia';
    encyclopediaApi.search(this.state.query, null, null, this.state.page).then(results => this.setState({results}));
  };

  revertSearch = () => {
    this.setState({query: ''});
  };

  toggleVideoFilter = () => this.setState(prevState => ({
    videosOnly: !prevState.videosOnly,
    page: 1,
  }), this.performSearch);

  topicChange = () => this.setState({page: 1}, this.performSearch);

  render() {
    const {article, defaultToPreviousEncyclopediaOverview, results, query, topic, hasBeenSearched} = this.state;
    let searchResults = results;
    let isSearching = (query && query.length || topic || !article) && !this.props.articleSlug;
    let {formatMessage} = this.props.intl;
    const hideSearchBar =  this.props.intl.locale === 'fr-CA';

    return <div className='page-encyclopedia'>
      <div className="container">
        <Header mainTitle={formatMessage({id: 'encyclopedia.support.title'})}
                mainTitleReturn='encyclopedia'
                subTitle={isSearching && hasBeenSearched ? formatMessage({id: 'general.search.results'}) : ''}/>
      </div>
      
      <div className='encyclopedia-row'>
        <div className='encyclopedia-col-search'>
          {!hideSearchBar ?
          <div className='well clearfix hidden-print'>
            <div className='col-sm-8'>
              <SearchField placeholder={formatMessage({id: 'general.search.articles.keyboards'})}
                          onSearch={this.filterChange}
                          initialValue={this.state.query}/>
            </div>
          </div> : null}

          {!isSearching ?
              !defaultToPreviousEncyclopediaOverview ?
                  !this.props.articleSlug ?
                      <Loader loaded={!!article}>
                          <ArticleContents article={article} formatMessage={formatMessage} disableFooter={true}/>
                      </Loader>
                  :
                      <EncyclopediaArticle slug={this.props.articleSlug} />
              :
              <div>
                  <FormattedMessage id='encyclopedia.overview.body' />
              </div> 
          :
          <EncyclopediaResults {...searchResults}
              query={this.state.query}
              onResultClick={article => this.navigateToArticle(article.id)}
              onPageChange={this.onPageChange}
              formatMessage={formatMessage}/>
          }
        </div>
        <div className='encyclopedia-divider hidden-print'></div>
        <div className='encyclopedia-col-files hidden-print'>
          <FileBrowser />
        </div>
      </div>
    </div>
  }
}

let WrappedEncyclopediaPage = injectIntl(EncyclopediaPage);

export default WrappedEncyclopediaPage;
